<template>
  <div class="mb-4">
    <div class="p-2" :style="!!maxHeight ? 'max-height: 300px; overflow: auto; border: 1px solid #dee2e6;' : ''">
      <div v-html="question.description"></div>
      <b-form-group>
        <b-form-checkbox
          :size="size"
          v-model="answer"
          :name="question.slug"
          required
          :state="!!errors ? false : null"
          :placeholder="question.placeholder"
          @change="$emit('clear-error', question.slug)"
        >
          {{ question.label }} {{ question.required ? '*' : '' }}
        </b-form-checkbox>
        <b-form-invalid-feedback :state="!!errors ? false : null">
          {{ (errors||[]).join(' ') }}
        </b-form-invalid-feedback>
      </b-form-group>
    </div>
    <small v-if="!!maxHeight" class="d-block mt-2">
      {{ trans('please_scroll_bottom') }}
    </small>
  </div>
</template>

<script>
  export default {
    props: {
      value: Boolean, // answer
      question: Object,
      disabled: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: 'md',
      },
      errors: Array,
    },
    data() {
      return {
        trans: trans,
        answer: this.value || null,
      }
    },
    computed: {
      maxHeight() {
        return this.question && this.question.options && this.question.options.max_height ?
          this.question.options.max_height :
          null
      },
    },
    watch: {
      answer() {
        this.$emit('input', this.answer)
      },
      value() {
        this.answer = this.value || null
      },
    },
  }
</script>